import capitalize from 'lodash.capitalize'

// Some org records store their slug as the name ("singapore-management-university"). Only that shape is
// rewritten as words; a real name that happens to contain a hyphen ("University of Pretoria - Main
// Administration") is left alone.
const SLUG = /^[a-z0-9]+(-[a-z0-9]+)+$/

export const normalizeLicenseName = (name?: string | null): string => {
  if (!name) {
    return 'Your institution'
  }
  return SLUG.test(name) ? name.split('-').map(capitalize).join(' ') : name
}
